module.exports = __webpack_public_path__ + "new_collection_icon.724b2ee9e02d502cb8d833404a212817.svg";